import * as React from 'react';
import styled from '@emotion/styled';
import { observer } from 'src/utils/mobx-react';

interface PropsType {
    className?: string;
    onClick?: () => void;
}

const SvgElement = styled('svg', { label: 'SvgElement' })`
    height: auto;
`;

export const BasketballIcon = observer('BasketballIcon', ({ className, onClick }: PropsType): JSX.Element => {
    return (
        <SvgElement
            xmlns='http://www.w3.org/2000/svg'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            fill='#061A32'
            className={className}
            onClick={onClick}
        >
            <path
                d='M12.9723 2.11891C13.0045 2.68016 13.0409 3.31639 12.8146 3.61636C12.625 3.86798 12.2776 4.23388 11.817 4.63025C10.4671 3.67137 9.25266 3.02241 8.46808 2.64536C9.56793 2.22943 10.7596 2 12.005 2C12.33 2 12.6512 2.01674 12.9684 2.04703L12.9723 2.11891Z'
                fill='fill'
            />
            <path
                d='M16.6191 9.5755C16.9748 9.46199 17.3907 9.38107 17.8838 9.32536C19.3017 9.16453 20.8392 10.9786 21.9999 12.4052C21.8987 14.9752 20.829 17.2954 19.1446 19.0117C18.9823 16.2946 18.3194 12.5441 16.6191 9.5755Z'
                fill='fill'
            />
            <path
                d='M7.77625 6.7629C8.9709 6.5143 10.0933 5.91303 10.9882 5.27835C9.12125 3.99253 7.56413 3.32523 7.25438 3.19821C5.31752 4.24526 3.7676 5.91352 2.86591 7.93487C4.03792 7.4679 5.30724 7.23032 6.55396 6.99884L6.55764 6.99816C6.95972 6.92348 7.37552 6.84625 7.77625 6.7629Z'
                fill='fill'
            />
            <path
                d='M15.0101 7.38102C14.9045 7.26997 14.7981 7.16096 14.6915 7.0538C15.7115 6.41269 16.5699 5.97527 17.1089 5.81428C17.9306 5.56909 18.7368 5.42144 19.46 5.33429C20.7848 6.81401 21.6739 8.69029 21.9305 10.7634C20.7338 9.39587 19.3395 8.15373 17.7714 8.3311C17.1059 8.40634 16.55 8.53278 16.0777 8.71109C15.7534 8.23765 15.3998 7.79016 15.0101 7.38102Z'
                fill='fill'
            />
            <path
                d='M13.3748 12.2207C13.7852 10.8308 14.2605 9.82889 15.1815 9.17853C14.9051 8.78176 14.6076 8.40938 14.2855 8.07111C14.1364 7.91458 13.9857 7.76341 13.8343 7.6149C10.1395 10.1298 5.07832 14.7497 4.6181 18.7524C6.15435 20.4333 8.2568 21.586 10.6236 21.913C11.4854 20.1972 12.2965 16.7093 12.7786 14.6349L12.7804 14.6272C13.0113 13.6341 13.2106 12.7768 13.3748 12.2207Z'
                fill='fill'
            />
            <path
                d='M13.0788 6.90945C11.8345 7.76501 10.474 8.82954 9.18574 10.0167C7.03699 11.9967 4.52644 14.8216 3.7945 17.7196C2.66468 16.0993 2 14.1303 2 12.0051C2 11.0551 2.13529 10.1371 2.38265 9.26643C3.65283 8.55774 5.16321 8.27476 6.73662 7.98258C7.14498 7.90677 7.56737 7.8283 7.97986 7.74246C9.45283 7.43611 10.806 6.67089 11.8396 5.89397C12.248 6.2042 12.6641 6.54248 13.0788 6.90945Z'
                fill='fill'
            />
            <path
                d='M13.9405 6.33797C15.1307 5.57914 16.1569 5.05445 16.8227 4.85571C17.4206 4.67716 18.0071 4.54711 18.5625 4.45227C17.2791 3.33703 15.7103 2.54217 13.9784 2.19571C14.0168 2.89445 14.0336 3.66159 13.6132 4.21895C13.4135 4.48363 13.0756 4.84663 12.636 5.24045C13.0666 5.57558 13.5041 5.94104 13.9405 6.33797Z'
                fill='fill'
            />
            <path
                d='M13.7532 14.8613C13.9812 13.8804 14.1782 13.0332 14.3344 12.504C14.6912 11.2961 15.0496 10.5175 15.7155 10.0226C17.4325 13.008 18.1141 17.0298 18.1813 19.8731C16.4802 21.2102 14.3367 22.0101 12.005 22.0101C11.9211 22.0101 11.8377 22.0072 11.7545 22.0043C11.7309 22.0035 11.7074 22.0027 11.6838 22.0019C12.436 20.3492 13.0801 17.7576 13.7532 14.8613Z'
                fill='fill'
            />
        </SvgElement>
    );
});
